import { Textarea } from '@/components/common/Textarea'
import { CheckboxGroup } from '@/components/common/CheckboxGroup'
import { StepShell } from '../StepShell'
import { INVESTIGATION_OPTIONS } from '@/lib/constants'

const DEFAULT = { investigations: [], notes: '' }

export function InvestigationStep({ value, onChange }) {
  const v = { ...DEFAULT, ...(value || {}) }
  const set = (patch) => onChange?.({ ...v, ...patch })

  return (
    <StepShell
      eyebrow="Section 9 — Phase 4"
      title="Investigations advised"
      description="Imaging and pulp/blood investigations to confirm diagnosis."
    >
      <CheckboxGroup
        label="Tests advised"
        options={INVESTIGATION_OPTIONS}
        value={v.investigations}
        onChange={(arr) => set({ investigations: arr })}
        columns={2}
      />
      <Textarea
        label="Notes / findings"
        rows={3}
        value={v.notes}
        onChange={(e) => set({ notes: e.target.value })}
        placeholder="Radiographic interpretation, vitality test result, etc."
      />
    </StepShell>
  )
}
